import { gql } from "@apollo/client";

export const VERIFY_AUTH = gql`
	query verifyAuth {
		verifyAuth
	}
`;
